import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'
import { MarketplacePartnerRegisterPageFormInputField } from '../MarketplacePartnerRegisterPageFormInputField'

export const MarketplacePartnerRegisterPageFormBasicInformationsCompanyInformations: FC =
  () => {
    const { formState } = useMarketplacePartnerRegisterPageContext()
    formState.use()

    return (
      <div className="flex flex-col gap-4">
        <div>
          <div className="text-l">
            <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.companyInformations.title" />
          </div>
          <FormattedMessage id="marketplacePartnerRegisterPage.basicInformations.companyInformations.description" />
        </div>

        <MarketplacePartnerRegisterPageFormInputField
          fieldName="name"
          label={<FormattedMessage id="general.label.companyName" />}
          required
        />

        <div className="flex flex-col gap-4 tablet:flex-row">
          <div className="grow">
            <MarketplacePartnerRegisterPageFormInputField
              fieldName="streetName"
              label={<FormattedMessage id="general.label.street" />}
              required
            />
          </div>
          <MarketplacePartnerRegisterPageFormInputField
            fieldName="streetNumber"
            label={<FormattedMessage id="general.label.streetNumber" />}
            required
          />
        </div>
        <MarketplacePartnerRegisterPageFormInputField
          fieldName="additionalAddress"
          label={<FormattedMessage id="general.label.additionalAddress" />}
        />
        <div className="flex flex-col gap-4 tablet:flex-row">
          <MarketplacePartnerRegisterPageFormInputField
            fieldName="postalCode"
            label={<FormattedMessage id="general.label.zip" />}
            required
          />
          <div className="grow">
            <MarketplacePartnerRegisterPageFormInputField
              fieldName="city"
              label={<FormattedMessage id="general.label.city" />}
              required
            />
          </div>
        </div>
        <MarketplacePartnerRegisterPageFormInputField
          fieldName="country"
          label={<FormattedMessage id="general.label.companyCountry" />}
          required
        />

        <MarketplacePartnerRegisterPageFormInputField
          fieldName="website"
          label={<FormattedMessage id="general.label.companyWebsite" />}
          required
        />
      </div>
    )
  }
